/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  plantGeneration (param) {
    return Api().get('/api/v1.0/plant_generation/' + param.plantId + '/' + param.startDate + '/' + param.endDate)
  },
  inverterEnergy  (param) {
    return Api().post('/api/v1.0/inv-generation', param)
  },
  inverterPower (param) {
    return Api().post('/api/v1.0/power', param)
  },
  getRoomList (plantId, blockId) {
    return Api().get('/api/v1.0/inverter_room_list/' + plantId + '/' + blockId)
  },
  getPr  (param) {
    return Api().get('/api/v1.0/irradiance/' + param.plantId + '/' + param.startDate + '/' + param.endDate)
  },
  getPlantGenration  (param) {
    return Api().post('/api/v1.0/plant-generation', param)
  },
  getInverterBlockGeneration (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/inverterBlockGeneration/${plantId}/${startDate}/${endDate}`)
  },
  getWindParam(plantId) {
    return Api().get(`api/v1.0/windparam/${plantId}`)
  },
  getWindSpeed(plantId) {
    return Api().get(`api/v1.0/windspeed/${plantId}`)
  },
  getTempParam(plantId) {
    return Api().get(`api/v1.0/tempParam/${plantId}`)
  },
  getTempData(plantId) {
    return Api().get(`api/v1.0/tempData/${plantId}`)
  },
  fetchHeader(param) {
    return Api().get(`api/v1.0/headers/${param.plantId}/${param.dateFrom}/${param.dateTo}`)
  },
  fetchInvList(plantId, startDate, endDate) {
    return Api().get(`api/v2/inverter/generation/${plantId}/${startDate}/${endDate}/day`)
  }
}
